import React, { FC } from 'react';

import { Box } from '@mui/system';
import { FormikProps } from 'formik';

import { NavigateToType } from '@pharmaplan/common';

import {
  BroadcastNavigationDropdown,
  TextFieldVariants,
} from '../../../../../../helpers/Constants';
import useBroadcastPharmacyNavigation from '../../../../../../hooks/Admin/BroadcastList/useBroadcastPharmacyNavigation';
import useBroadcastShiftDetails from '../../../../../../hooks/Admin/BroadcastList/useBroadcastShiftDetails';
import genericClasses from '../../../../../../theme/GenericClasses';
import CustomAutocomplete from '../../../../../common/CustomAutocomplete';
import CustomTextField from '../../../../../common/CustomTextField';
import CustomDropdown from '../../../../../common/CustomDropdown';
import strings from '../../../../../../localization';

import ReadOnlyNavigationField from './ReadOnlyNavigationField';
import styles from '../../styles';

const { filled } = TextFieldVariants;
const { ShiftURL, Pharmacy } = NavigateToType;

interface IBroadcastNavigationFields {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikProps<any>;
}

const BroadcastNavigationFields: FC<IBroadcastNavigationFields> = ({
  formik,
}) => {
  const { pharmacyOptions } = useBroadcastPharmacyNavigation(formik);

  useBroadcastShiftDetails(formik);

  const { navigateTo } = formik.values;

  const isShiftUrl = navigateTo === ShiftURL;
  const isPharmacy = navigateTo === Pharmacy;

  return (
    <>
      <CustomDropdown
        formik={formik}
        label={strings.navigationTo}
        horizontal
        name="navigateTo"
        variant={filled}
        placeholder={strings.selectNavigationTarget}
        showPlaceholder
        menuItems={BroadcastNavigationDropdown()}
      />

      {isShiftUrl && (
        <>
          <CustomTextField
            name="shiftUrl"
            formik={formik}
            label={strings.shiftUrl}
            horizontal
            variant={filled}
            id="shiftUrl"
            placeholder={strings.pasteCopiedShiftUrl}
            customTextFieldStyle={genericClasses.customFilledInput}
          />
          <ReadOnlyNavigationField name="shiftDetails" formik={formik} />
        </>
      )}

      {isPharmacy && (
        <>
          <Box sx={styles.autoCompleteContainer}>
            <CustomAutocomplete
              label={strings.pharmacy}
              idName="pharmacyId"
              textName="pharmacies"
              autoCompleteName="pharmacySelected"
              variant={filled}
              placeholder={
                strings.formatString(
                  strings.selectUser,
                  strings.pharmacy,
                ) as string
              }
              formik={formik}
              options={pharmacyOptions}
              customLabelStyle={styles.autoCompleteLabel}
              customAutoCompleteStyle={styles.autoComplete}
              customTextFieldStyle={styles.autoCompleteTextField}
            />
          </Box>

          <ReadOnlyNavigationField name="pharmacyUrl" formik={formik} />
        </>
      )}
    </>
  );
};

export default BroadcastNavigationFields;
